  import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonType } from '../../types/button-type.type';
import { CommonModule } from '@angular/common';
import { ButtonSize } from '../../types/button-size.type';

@Component({
  selector: 'app-button', 
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {

  @Input() type!: ButtonType;
  @Input() size!: ButtonSize;
  @Input() text!: string;
  @Input() disabled: boolean = false;
  @Input() pressed: boolean = false;
  @Input() loading: boolean = false;
  @Input() icon?: string;
  @Input() backgroundColor?: string;
  @Input() borderColor?: string;

  @Output() click = new EventEmitter<void>();

  @Output() startLoading = new EventEmitter<void>();



  getButtonClass(): string {
    let classes = 'rounded text-[16px] focus:outline-none transition-all rounded-[16px] flex items-center justify-center ';
  
    if (this.size === 'xSmall') {
      classes = classes.replace('text-[16px]', 'text-[12px]');
    }
  
    switch (this.size) {
      case 'small':
        classes += 'w-[162px] h-[40px] ';
        break;
      case 'xSmall':
        classes += 'w-[78px] h-[32px] ';
        break;
      case 'medium':
        classes += 'w-[162px] h-[48px] ';
        break;
      case 'large':
        classes += 'w-[178px] h-[56px] ';
        break;
      case 'mediumLarge':
        classes += 'w-[275px] h-[48px] ';
      break;
      case 'xLarge':
        classes += 'w-[392px] h-[48px] ';
      break;
      case 'full':
        classes += 'w-full h-[48px] ';
      break;
      case 'mFull':
        classes += 'w-[184px] h-[48px] ';
      break;
      case 'xMedium':
        classes += 'w-[115px] h-[48px] ';
      break;
      case 'customSize':
        classes += 'w-[151px] h-[48px] ';
        break;
      default:
        classes += 'w-[174px] h-[48px] ';
        break;
    }
  

    if (this.disabled) {
      if (this.type === 'icon' || this.type === 'iconDanger') {

        classes += ' bg-transparent text-[#C2C2C2] border-[2px] border-[#F5F5F5] cursor-not-allowed opacity-70 ';
      }else if (this.type === 'transparentIcon' || this.type === 'transparentDanger') {

        classes += ' text-[#C2C2C2] cursor-not-allowed opacity-70 ';
        
      } 
       else {

        classes += ' bg-[#F5F5F5] text-[#C2C2C2] cursor-not-allowed opacity-70 ';
      }
    } else {

      switch (this.type) {
        case 'primary':
          classes += ' bg-[#0A4E8F] text-white hover:bg-[#346CA2] active:bg-[#073764]';
          break;
        case 'primaryIcon':
          classes += ' bg-[#0A4E8F] text-white hover:bg-[#346CA2] active:bg-[#073764]';
          break;
        case 'secondary':
          classes += ' bg-[#E42131] text-white';
          break;
        case 'icon':
          classes += ` bg-${this.backgroundColor ?? 'transparent'} text-[#0A4E8F] border-[2px] hover:border-[#346CA2] active:border-[#073764] hover:text-[#346CA2] active:text-[#073764] ${this.borderColor ? `border-${this.borderColor}` : 'border-transparent'}`;
          break;
        case 'iconDanger':
          classes += ' bg-[#FFFFFF] text-[#FF3030] border-[2px] border-[#FF3030]';
          break;
        case 'transparentIcon':
          classes += 'text-[#063057] hover:text-[#063057] active:text-[#063057] border-none focus:outline-none focus:ring-0 transparent-button'; 
          break;
        case 'transparentDanger':
          classes += 'text-[#FF3030]  border-none focus:outline-none focus:ring-0 transparent-button';
          break;
        case 'transparentIconBlack':
          classes += 'border-none focus:outline-none focus:ring-0 transparent-button';
          break;
        case 'xTable':
          classes += ' bg-[#FF3030] text-white ';
          break;
        case 'loader':
          classes += ' bg-[#0A4E8F] text-white hover:bg-[#083A5E]';
          break;
      }
    }
  
    return classes;
  }
  
  
  onClick() {
    if(this.type === 'loader') {
      this.startLoading.emit();
    }else{
      this.click.emit();
    }
  }


}
